import { AuthorizedInstallersContext } from '@authorizedInstaller/contexts';
import {
    AuthorizedInstallerApplication,
    IAuthorizedInstallersFile,
} from '@authorizedInstaller/types/authorizedInstallers';
import { FileUpload, FileUploadProps } from '@components/utility/files';
import { useContext } from 'react';

const UploadStep = (
    fileUploadProps: Omit<FileUploadProps<IAuthorizedInstallersFile, AuthorizedInstallerApplication>, 'formik'>
) => {
    const { formik } = useContext(AuthorizedInstallersContext);
    return (
        <FileUpload<IAuthorizedInstallersFile>
            {...fileUploadProps}
            formik={formik}
            fileDropzoneAreaProps={{ multiple: true, showButton: true }}
        />
    );
};

export { UploadStep };
